import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import { IconButton, TextField } from '@totalsoft/rocket-ui';
import { IncomeSchemaFeeApprovalStatus } from '../../../../../../constants/incomeSchema';
import { ParamsContext } from 'providers/ParamsContext';

export const OfferFeeCatalogListItemComponentWithNegotiation = ({
  t,
  fee,
  readOnlyFull,
  saving,
  onPropertyChange,
  idx,
  handleApprovalButtons,
  hasApproveRightsLevel1,
  hasApproveRightsLevel2
}) => {
  const { cvsChPercent } = useContext(ParamsContext);
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} md={4} sm={4}>
          <TextField
            id={'offerFeeCatalogCard_' + idx + '_name'}
            label={t('OfferEdit.FeeCatalog.Fee')}
            name={'name'}
            fullWidth
            value={!fee || !fee.name ? '' : fee.name}
            disabled={true}
          />
        </Grid>
        <Grid item xs={12} md={4} sm={4}>
          <TextField
            id={'offerFeeCatalogCard_' + idx + '_Status'}
            label={t('OfferEdit.FeeCatalog.NegotiationStatusName')}
            name={'status'}
            fullWidth
            value={!fee || !fee.approvalStatus ? '' : t(`OfferEdit.FeeCatalog.${fee.approvalStatus}`)}
            disabled={true}
          />
        </Grid>

        <Grid item xs={12} md={4} sm={4}>
          <TextField
            id={'offerFeeCatalogCard_' + idx + '_percent'}
            label={t('OfferEdit.FeeCatalog.Percent')}
            name={'percent'}
            fullWidth
            isNumeric
            value={!fee || (!fee.percent && fee.percent !== 0) ? '' : t('NUMBER', { number: fee.percent })}
            inputProps={{ decimalScale: cvsChPercent }}
            disabled={true}
          />
        </Grid>
        <Grid item xs={12} md={4} sm={4}>
          <TextField
            id={'offerFeeCatalogCard_' + idx + '_percentProposed'}
            label={t('OfferEdit.FeeCatalog.PercentProposed')}
            name={'percentProposed'}
            fullWidth
            isNumeric
            value={!fee || (!fee.percentProposed && fee.percentProposed !== 0) ? '' : t('NUMBER', { number: fee.percentProposed })}
            onChange={onPropertyChange('percentProposed')}
            inputProps={{ decimalScale: cvsChPercent }}
            disabled={fee.approvalStatus !== IncomeSchemaFeeApprovalStatus.IN_NEGOTIATION}
          />
        </Grid>
        {fee.showAmount && (
          <>
            <Grid item xs={12} md={4} sm={4}>
              <TextField
                id={'offerFeeCatalogCard_' + idx + '_value'}
                label={t('OfferEdit.FeeCatalog.Value', { currencyCode: fee.currencyCode })}
                name='value'
                fullWidth
                isNumeric
                value={!fee || (!fee.value && fee.value !== 0) ? '' : fee.value}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={4}>
              <TextField
                id={'offerFeeCatalogCard_' + idx + '_valueProposed'}
                label={t('OfferEdit.FeeCatalog.ValueProposed', { currencyCode: fee.currencyCode })}
                name='valueProposed'
                fullWidth
                isNumeric
                value={!fee || (!fee.valueProposed && fee.valueProposed !== 0) ? '' : fee.valueProposed}
                onChange={onPropertyChange('valueProposed')}
                disabled={fee.approvalStatus !== IncomeSchemaFeeApprovalStatus.IN_NEGOTIATION}
              />
            </Grid>
          </>
        )}
        <Grid item xs={12} md={4}>
          <TextField
            id={'offerFeeCatalogCard_' + idx + '_FirstApprovalUser'}
            label={t('OfferEdit.FeeCatalog.FirstApprovalUserName')}
            name={'status'}
            fullWidth
            value={!fee || !fee.firstApprovalUserName ? '' : fee.firstApprovalUserName}
            disabled={true}
            endAdornment={
              <>
                <IconButton
                  id={'IncomeFeeCard_summary_' + idx + '_firstApprovedBtn'}
                  color='success'
                  variant='text'
                  size='tiny'
                  onClick={handleApprovalButtons('yes_1')}
                  disabled={
                    readOnlyFull ||
                    saving ||
                    !fee ||
                    !hasApproveRightsLevel1 ||
                    fee.approvalStatus !== IncomeSchemaFeeApprovalStatus.IN_PROGRESS
                  }
                >
                  <CheckCircle />
                </IconButton>
                <IconButton
                  id={'IncomeFeeCard_summary_' + idx + '_FirstRejectedBtn'}
                  color='error'
                  variant='text'
                  size='tiny'
                  onClick={handleApprovalButtons('no_1')}
                  disabled={
                    readOnlyFull ||
                    saving ||
                    !fee ||
                    !hasApproveRightsLevel1 ||
                    fee.approvalStatus !== IncomeSchemaFeeApprovalStatus.IN_PROGRESS
                  }
                >
                  <Cancel />
                </IconButton>
              </>
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            id={'offerFeeCatalogCard_' + idx + '_SecondApprovalUser'}
            label={t('OfferEdit.FeeCatalog.SecondApprovalUserName')}
            name={'status'}
            fullWidth
            value={!fee || !fee.secondApprovalUserName ? '' : fee.secondApprovalUserName}
            disabled
            endAdornment={
              <>
                <IconButton
                  id={'IncomeFeeCard_summary_' + idx + '_SecondApprovedBtn'}
                  color='success'
                  variant='text'
                  size='tiny'
                  onClick={handleApprovalButtons('yes_2')}
                  disabled={
                    readOnlyFull ||
                    saving ||
                    !fee ||
                    !hasApproveRightsLevel2 ||
                    fee.approvalStatus !== IncomeSchemaFeeApprovalStatus.APPROVAL_1
                  }
                >
                  <CheckCircle />
                </IconButton>
                <IconButton
                  id={'IncomeFeeCard_summary_' + idx + '_SecondRejectedBtn'}
                  color='error'
                  variant='text'
                  size='tiny'
                  onClick={handleApprovalButtons('no_2')}
                  disabled={
                    readOnlyFull ||
                    saving ||
                    !fee ||
                    !hasApproveRightsLevel2 ||
                    fee.approvalStatus !== IncomeSchemaFeeApprovalStatus.APPROVAL_1
                  }
                >
                  <Cancel />
                </IconButton>
              </>
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

OfferFeeCatalogListItemComponentWithNegotiation.propTypes = {
  fee: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired,
  saving: PropTypes.bool.isRequired,
  handleApprovalButtons: PropTypes.func.isRequired,
  hasApproveRightsLevel1: PropTypes.bool.isRequired,
  hasApproveRightsLevel2: PropTypes.bool.isRequired,
  readOnlyFull: PropTypes.bool.isRequired
};

export default compose(withTranslation()(OfferFeeCatalogListItemComponentWithNegotiation));
